/**
 * Sample-data mode ("Ukázková data"): a switch kept in this tab's
 * sessionStorage. While it is on, the Supabase client answers company data
 * from in-browser fixtures and refuses every write (`./backend.ts`), so nothing
 * reaches the database, exports, AI quotas, billing counts or digests.
 *
 * Per tab on purpose: a new tab, or closing this one, is the real company again.
 */

const KEY = "zettl:demo";
const listeners = new Set<() => void>();
let memory = false;

function readStorage(): boolean {
  try {
    return window.sessionStorage.getItem(KEY) === "1";
  } catch {
    return memory;
  }
}

let current: boolean = typeof window === "undefined" ? false : readStorage();

/** Whether this tab shows sample data. Read synchronously by the fetch layer. */
export function isDemoMode(): boolean {
  return current;
}

export function setDemoMode(on: boolean): void {
  if (on === current) return;
  current = on;
  memory = on;
  try {
    if (on) window.sessionStorage.setItem(KEY, "1");
    else window.sessionStorage.removeItem(KEY);
  } catch {
    // blocked storage: the mode lasts until the page reloads
  }
  listeners.forEach((listener) => listener());
}

export function subscribeDemoMode(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
